var basketGsmConfirmation = function () {

    $('[data-must-confirm-gsm]').gsmConfirmation({
        additionalInputName: 'payment_method_id',
        beforeSubmit: function () {
            App.prototype.manuallySetIntlTelInputValueForAjax();
        },
        locale: translates.basketGsmConfirmation
    });

};
App.prototype.pageDetector('basket-page', basketGsmConfirmation);
